import { useMemo } from "react";
import { Stack } from "@mantine/core";
import { ReportPhotoContent, type OrganMapPhoto } from "./ReportPhotoContent";

interface Props {
  photos: OrganMapPhoto[];
  rowIndex?: number;
}

export function LegacyHistoricalPhotos({ photos, rowIndex }: Props) {
  const selected = useMemo(
    () =>
      rowIndex === undefined ? photos : photos.slice(rowIndex, rowIndex + 1),
    [photos, rowIndex]
  );
  return (
    <Stack gap="md" mt="8pt" data-historical-new-images="true">
      {selected.map((photo) => (
        <ReportPhotoContent
          key={photo.image.id}
          {...photo}
          layout={{ width: "100%", maxWidth: "100%", maxHeight: "400pt" }}
        />
      ))}
    </Stack>
  );
}
